import { render } from "./dashboard.vue?vue&type=template&id=5602bbe0&scoped=true&ts=true"
import script from "./dashboard.vue?vue&type=script&lang=ts"
export * from "./dashboard.vue?vue&type=script&lang=ts"

import "./dashboard.vue?vue&type=style&index=0&id=5602bbe0&scoped=true&lang=css"

import exportComponent from "/vercel/path2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5602bbe0"]])

export default __exports__